import React from 'react';
import defaultConfig from './alme-config/appConfigMain';
import App from './App';
import { isMobileDevice } from './components/AlmeUtilities/device-utils';
import { ConsoleLogger, defaultLogLevel } from './Logger';
import { hasVistaChatPropValidationError } from './IVAChatPropValidation';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
const hasInvalidProps = (props, logger) => {
    return props.platform === "VISTA" && hasVistaChatPropValidationError(props, logger);
};
const getcorrelationId = () => {
    return sessionStorage.getItem('correlationId') || undefined;
};
const IVAChat = (props) => {
    const logger = ConsoleLogger.getInstance(defaultLogLevel);
    if (hasInvalidProps(props, logger)) {
        return null;
    }
    /**
    * Update function updateAppConfigState on adding new Node module specific props
    */
    const appConfig = Object.assign(Object.assign({}, defaultConfig), { main: {
            apiHostName: props.apiHostName,
            appAccessKey: props.appAccessKey,
            isLoggedIn: props.isLoggedIn,
            showIvaChatIcon: props.showIvaChatIcon,
            clientSessionId: props.clientSessionId,
            userMetadata: props.userMetadata,
            platform: props.platform,
            interactionId: getcorrelationId(),
        }, get webUrl() { return `https://${props.apiHostName}/Alme`; } });
    appConfig.isMobile = isMobileDevice();
    if (appConfig.isMobile) {
        appConfig.channel = "MobileWeb";
    }
    return (React.createElement(ErrorBoundary, { appConfig: appConfig },
        React.createElement(App, { isOpen: props.isOpen, onMinimize: props.onMinimize, onClose: props.onClose, appConfig: appConfig })));
};
export default IVAChat;
